import { useEffect, useState } from 'react';
import { ListTeam } from 'generated-graphql/types';
import { useFetchListTeams } from 'modules/candidate-profile/hooks/useFetchListTeams';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';

// The teams the user can put a talent list in, when teams are on.
export const useListTeams = () => {
  const isEnabled = Boolean(useFlag(Flags.TALENT_LIST_TEAMS));
  const { fetchListTeams } = useFetchListTeams();
  const [teams, setTeams] = useState<ListTeam[]>([]);
  const [isLoading, setIsLoading] = useState(isEnabled);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setTeams([]);
    setIsError(false);
    setIsLoading(isEnabled);
    if (!isEnabled) {
      return;
    }

    const loadTeams = async () => {
      try {
        setTeams(await fetchListTeams());
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    loadTeams();
  }, [isEnabled]);

  return { isEnabled, teams, isLoading, isError };
};
